import { render, staticRenderFns } from "./new-index.vue?vue&type=template&id=6facd013&scoped=true&"
import script from "./new-index.vue?vue&type=script&lang=js&"
export * from "./new-index.vue?vue&type=script&lang=js&"
import style0 from "./new-index.vue?vue&type=style&index=0&id=6facd013&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6facd013",
  null
  
)

export default component.exports